import { ConstOptions } from 'common/constants/classes';

import {
  EventAttendeeType,
  EventOverbookingType,
  EventRepeatEnd,
  EventRepeatFrequency,
  EventRepeatTypes,
} from 'modules/booking/interfaces';

import commonMessages from 'common/messages/messages';
import messages from 'modules/booking/messages';

export enum BookingPaths {
  BookingEvents = '/',
}

export const actionTypes = {
  RESET_BOOKING_EVENT_DETAILS: 'RESET_BOOKING_EVENT_DETAILS',

  // Resource action types
  FETCH_RESOURCES_LIST_LOADING: 'FETCH_RESOURCES_LOADING',
  FETCH_RESOURCES_LIST_SUCCESS: 'FETCH_RESOURCES_SUCCESS',
  RESET_RESOURCES_LIST: 'RESET_RESOURCES_LIST',

  RESET_RESOURCE_FORM: 'RESET_RESOURCE_FORM',
  RESET_RESOURCE_ACTION_RESULT: 'RESET_RESOURCE_ACTION_RESULT',

  FETCH_RESOURCE_LOADING: 'FETCH_RESOURCE_LOADING',
  FETCH_RESOURCE_SUCCESS: 'FETCH_RESOURCE_SUCCESS',

  CREATE_RESOURCE_LOADING: 'CREATE_RESOURCE_LOADING',
  CREATE_RESOURCE_SUCCESS: 'CREATE_RESOURCE_SUCCESS',
  CREATE_RESOURCE_ERROR: 'CREATE_RESOURCE_ERROR',

  UPDATE_RESOURCE_LOADING: 'UPDATE_RESOURCE_LOADING',
  UPDATE_RESOURCE_SUCCESS: 'UPDATE_RESOURCE_SUCCESS',
  UPDATE_RESOURCE_ERROR: 'UPDATE_RESOURCE_ERROR',

  DELETE_RESOURCE_LOADING: 'DELETE_RESOURCE_LOADING',
  DELETE_RESOURCE_SUCCESS: 'DELETE_RESOURCE_SUCCESS',

  CHANGE_RESOURCE_STATUS: 'CHANGE_RESOURCE_STATUS',
  CHANGE_RESOURCE_STATUS_LOADING: 'CHANGE_RESOURCE_STATUS_LOADING',
  RESET_RESOURCE_CHANGE_STATUS: 'RESET_RESOURCE_CHANGE_STATUS',

  // Event services
  FETCH_EVENT_SERVICES_LOADING: 'BOOKING/FETCH_EVENT_SERVICES_LOADING',
  FETCH_EVENT_SERVICES: 'BOOKING/FETCH_EVENT_SERVICES',
  RESET_EVENT_SERVICES: 'BOOKING/RESET_EVENT_SERVICES',
};

// Sender availability
export const FETCH_SENDER_AVAILABILITY_LOADING = 'FETCH_SENDER_AVAILABILITY_LOADING';
export const FETCH_SENDER_AVAILABILITY = 'FETCH_SENDER_AVAILABILITY';
export const RESET_SENDER_AVAILABILITY = 'RESET_SENDER_AVAILABILITY';

export const Repeats = [
  { key: EventRepeatTypes.NONE, value: false, message: commonMessages.noneOption },
  { key: EventRepeatTypes.CUSTOM, value: true, message: commonMessages.customOption },
];

export const RepeatFrequencies = new ConstOptions([
  {
    key: EventRepeatFrequency.DAILY,
    value: EventRepeatFrequency.DAILY,
    message: messages.repeatFrequencyDaily,
  },
  {
    key: EventRepeatFrequency.WEEKLY,
    value: EventRepeatFrequency.WEEKLY,
    message: messages.repeatFrequencyWeekly,
  },
  {
    key: EventRepeatFrequency.MONTHLY,
    value: EventRepeatFrequency.MONTHLY,
    message: messages.repeatFrequencyMonthly,
  },
  {
    key: EventRepeatFrequency.SEMI_ANNUALLY,
    value: EventRepeatFrequency.SEMI_ANNUALLY,
    message: messages.repeatFrequencySemiAnnually,
  },
  {
    key: EventRepeatFrequency.ANNUALLY,
    value: EventRepeatFrequency.ANNUALLY,
    message: messages.repeatFrequencyAnnually,
  },
]);

export const RepeatEnds = new ConstOptions([
  {
    key: EventRepeatEnd.FOREVER,
    value: EventRepeatEnd.FOREVER,
    message: messages.repeatEndForever,
  },
  {
    key: EventRepeatEnd.N_TIMES,
    value: EventRepeatEnd.N_TIMES,
    message: messages.repeatEndTimes,
  },
  {
    key: EventRepeatEnd.ON_DATE,
    value: EventRepeatEnd.ON_DATE,
    message: messages.repeatEndOnDate,
  },
]);

export const AttendeeTypes = new ConstOptions([
  {
    key: EventAttendeeType.MEMBER,
    value: EventAttendeeType.MEMBER,
    message: messages.attendeeTypeMember,
  },
  {
    key: EventAttendeeType.PROSPECT,
    value: EventAttendeeType.PROSPECT,
    message: messages.attendeeTypeProspect,
  },
  {
    key: EventAttendeeType.EMPLOYEE,
    value: EventAttendeeType.EMPLOYEE,
    message: messages.attendeeTypeEmployee,
  },
  {
    key: EventAttendeeType.RESOURCE_EMPLOYEE,
    value: EventAttendeeType.RESOURCE_EMPLOYEE,
    message: messages.attendeeTypeEmployee,
  },
]);

export const OverbookingTypes = new ConstOptions([
  {
    key: EventOverbookingType.DO_NOT_ALLOW_OVERBOOKING,
    value: EventOverbookingType.DO_NOT_ALLOW_OVERBOOKING,
    message: messages.overbookingTypeNotAllowed,
  },
  {
    key: EventOverbookingType.WAIT_LIST,
    value: EventOverbookingType.WAIT_LIST,
    message: messages.overbookingTypeWaitlist,
  },
  {
    key: EventOverbookingType.DUPLICATE_EVENT_FOR_EXTRA_PARTICIPANTS,
    value: EventOverbookingType.DUPLICATE_EVENT_FOR_EXTRA_PARTICIPANTS,
    message: messages.overbookingTypeDuplicateEvent,
  },
]);
